import { ErrorHandler, Injectable, inject } from '@angular/core';
import { BugReportService } from '../service/bug-report.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private bugReportService = inject(BugReportService);

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
      return;
    }

    this.bugReportService.addError({
      message: error.message || error.toString(),
      stack: error.stack,
      timestamp: Date.now(),
      type: 'console',
      details: error
    });

    console.error('GlobalErrorHandler:', error);
  }
}
